export default __webpack_public_path__ + "static/colorUSU-ac5a6abcb900eed912f6f274a62a3fad.png";